// Port of api/fuel/app/classes/filter/package/games/play/package/games/counts.php
export default {
	require: function(config, filter) { return filter.play && filter.play.group },
	run: function(pkg, local) {
		pkg.counts = local.counts || {}
		return pkg
	}
}
